import styled from "styled-components";

export const StyledBreadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StyledBreadcrumbItem = styled.div<{ onClick?: CallableFunction }>`
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;
